import { jsx as _jsx } from "react/jsx-runtime";
var CalendarOutline = function CalendarOutline(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 16 16",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.66732 2.66667C4.66732 2.29848 4.96579 2 5.33398 2C5.70217 2 6.00065 2.29848 6.00065 2.66667L10.0007 2.66667C10.0007 2.29848 10.2991 2 10.6673 2C11.0355 2 11.334 2.29848 11.334 2.66667L13.334 2.66667C14.0704 2.66667 14.6673 3.26362 14.6673 4V12C14.6673 12.7364 14.0704 13.3333 13.334 13.3333H2.66732C1.93094 13.3333 1.33398 12.7364 1.33398 12V4C1.33398 3.26362 1.93094 2.66667 2.66732 2.66667L4.66732 2.66667ZM10.0007 4C10.0007 4.36819 10.2991 4.66667 10.6673 4.66667C11.0355 4.66667 11.334 4.36819 11.334 4L13.334 4L13.334 5.33333H2.66732V4L4.66732 4C4.66732 4.36819 4.96579 4.66667 5.33398 4.66667C5.70217 4.66667 6.00065 4.36819 6.00065 4L10.0007 4ZM2.66732 6.66667V12H13.334L13.334 6.66667H2.66732Z",
      fill: !ignoreColor ? color : undefined
    })
  });
};
export default CalendarOutline;